export default __webpack_public_path__ + "static/media/bw.b6a321af.svg";